<template>
  <el-dialog
    title="密码修改"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="200px"
            size="small"
    >
      <el-form-item
                    prop="oldPassword"
                    label="请输入原密码"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.oldPassword"></el-input>
      </el-form-item>
      <el-form-item
              prop="newPassword"
              label="请输入新密码"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.newPassword"></el-input>
      </el-form-item>
      <el-form-item
              prop="secondPassword"
              label="请再次输入新密码"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.secondPassword"></el-input>
      </el-form-item>


      <el-form-item >
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:60%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "passwordForm",
    components:{
    },
  props: {
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
          oldPassword: "",
          newPassword: "",
          secondPassword: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        this.form = {};
    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                      this.loading = true;
                      agentService.getPassword({ ...this.form,userid:util.cookies.get('uuid')})
                          .then(data => {
                              this.loading = false;
                              console.info("-----------"+data);
                              if(data=='000'){
                                  this.$message("修改成功");
                                  this.dialogVisible = false;
                              this.$emit("submit");
                              }else if(data=='001'){
                                 this.$message("用户未登陆");
                              }else if(data=='002'){
                                  this.$message("两次新密码不一致");
                              }else if(data=='003'){
                                  this.$message("原密码错误");
                              }else if(data=='004'){
                                  this.$message("修改失败");
                              }
                          });
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

